import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';

import type { InfoType } from '../types';

export function NoData({ infoType }: { infoType: InfoType }) {
  const { t } = useTranslation('roster');
  const title =
    infoType === 'artist'
      ? t('contactInfo.noData.artist.title')
      : t('contactInfo.noData.songwriter.title');

  const caption =
    infoType === 'artist' ? t('contactInfo.noData.artist.caption') : undefined;

  return (
    <div className="flex w-full gap-md py-xs">
      <div className="flex items-center justify-center gap-md rounded-sm px-md py-sm text-left">
        <span>
          <Icon
            type="user-large-slash"
            size="2xl"
            variant="light"
            aria-hidden
          />
        </span>
        <div className="flex flex-col gap-xs">
          <span className="text-body-md font-bold">{title}</span>
          {caption ? <span className="text-body-sm">{caption}</span> : null}
        </div>
      </div>
    </div>
  );
}

NoData.displayName = 'NoData';
